module.exports = __webpack_public_path__ + "static/img/logo_img.924a595.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo_img.png
// module id = v/Iv
// module chunks = 1